import { Button } from "antd";
import React from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import styles from "./notes.module.scss";

const SaveButton = ({ onClick, style }: { onClick: () => void; style?: React.CSSProperties }) => {
  const componentName = "notes";
  const { isDemoPath } = useAppSelector((state) => state.appState);
  return (
    <div className={`${styles[`${componentName}__main-section-action`]}`} style={style}>
      {!isDemoPath && (
        <Button type="primary" onClick={onClick} className={`${styles[`${componentName}__main-section-save-button`]}`}>
          Save Changes
        </Button>
      )}
    </div>
  );
};

export default SaveButton;
